import React from 'react';
import s from '../s.module.less';

type Props = {
    num: number;
    title: string;
    sub: string;
    first?: boolean;
    last?: boolean;
};

// 编号步骤行：listing 预览与 EHR 介绍共用
export default function StageRow({ num, title, sub, first, last }: Props) {
    return (
        <div className={`${s.stage}${first ? ` ${s.first}` : ''}${last ? ` ${s.last}` : ''}`}>
            <span className={s.stageNum}>{num}</span>
            <div>
                <div className={s.stageTitle}>{title}</div>
                <div className={s.stageSub}>{sub}</div>
            </div>
        </div>
    );
}
